const furAmountOptions = [
    { value: 'little', label: { en: 'Little', es: 'Poco' } },
    { value: 'normal', label: { en: 'Normal', es: 'Normal' } },
    { value: 'a_lot', label: { en: 'A Lot', es: 'Mucho' } },
];

export default furAmountOptions;